"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = ({ colour = "currentColor" }) => {
    return (react_1.default.createElement("path", { d: "M10.5 7C9.67157 7 9 7.67157 9 8.5V31.5C9 32.3284 9.67157 33 10.5 33C11.3284 33 12 32.3284 12 31.5V25.6033C13.2153 25.8145 14 26 15.5 26C17 26 18.3 25.5 20 25C21.7 24.5 23 24 24.5 24C26 24 28.3296 24.4376 29.7702 24.7338C30.4007 24.8635 31 24.3845 31 23.7408V9.79413C31 9.32911 30.6811 8.92628 30.2263 8.82934C28.8865 8.54376 26 8 24.5 8C23 8 21.7 8.5 20 9C18.3 9.5 17 10 15.5 10C14 10 13.2153 9.81449 12 9.60328V8.5C12 7.67157 11.3284 7 10.5 7Z", fill: colour }));
};
//# sourceMappingURL=Flag.js.map